/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog } from '@fortawesome/free-solid-svg-icons';

import RefDesModal from 'shared/product_tabs/tab_parts/components/import/workbook/ref_des_modal';
import WTable from 'shared/product_tabs/tab_parts/components/import/workbook/w_table';
import {
  changeRefDesSeparator,
  changeRefDesRangeSeparator,
} from 'shared/product_tabs/tab_parts/bomSlice';

const Workbook = (props) => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);

  const {
    ref_des_separator,
    ref_des_range_separator,
    header,
    first_row,
    bom_parameters,
    workbook,
  } = props;

  const onSaveRefs = (new_ref_des_separator, new_ref_des_range_separator) => {
    dispatch(changeRefDesSeparator(new_ref_des_separator));
    dispatch(changeRefDesRangeSeparator(new_ref_des_range_separator));
    setShow(false);
  };

  const onShow = (e) => {
    e.preventDefault();
    setShow(true);
  };

  return (
    <div className="bom-file-preview">
      <div className="d-flex justify-content-center mt-4 mb-3">
        <span className="fw-bold text-primary">
          USE DROPDOWNS TO IDENTIFY THE FOLLOWING COLUMNS IN YOUR BOM (REF
          DESIGNATOR, QTY PER BOARD, MFG PART #){' '}
        </span>
      </div>
      <div className="ref-config mb-1">
        <a className="designator-link variant-link" href="#" onClick={onShow}>
          <FontAwesomeIcon icon={faCog} /> REF. DESIGNATOR SETTINGS
        </a>
        <RefDesModal
          ref_des_separator={ref_des_separator}
          ref_des_range_separator={ref_des_range_separator}
          show={show}
          onHide={() => setShow(false)}
          onSaveRefs={onSaveRefs} />
      </div>
      <div className="import-table table-responsive">
        <WTable
          header={header}
          first_row={first_row}
          bom_parameters={bom_parameters}
          workbook={workbook} />
      </div>
    </div>
  );
};

export default Workbook;
